.settings-modal {
  iframe {
    border: 0;
    height: 650px;
    width: 100%;
  }
}
